
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contents/[id]/[[...slug]]",
      function () {
        return require("private-next-pages/contents/[id]/[[...slug]].tsx");
      }
    ]);
  